var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic_wrap"},[(_vm.iframeSrc)?_c('iframe',{staticClass:"external-link",attrs:{"src":_vm.iframeSrc,"frameborder":"0","allowfullscreen":"","scrolling":"yes"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }